import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["historyList"]

  toggle() {
    this.element.classList.toggle("chat-sidebar--collapsed")
  }

  openOnboarding() {
    const onboardingModal = document.querySelector('[data-copilot-target="onboardingModal"]')
    if (!onboardingModal) return

    onboardingModal.style.display = ''
    const modalElement = onboardingModal.querySelector('[data-modal-target="modal"]')
    if (modalElement) {
      modalElement.style.display = 'flex'
    }
  }

  toggleHistory() {
    if (this.hasHistoryListTarget) {
      this.historyListTarget.classList.toggle("tw-hidden")
    }

    const chevron = this.element.querySelector('.chat-sidebar-chevron')
    if (chevron) {
      chevron.classList.toggle('chat-sidebar-chevron--collapsed')
    }

    const toggleDiv = this.element.querySelector('.chat-sidebar-chevron').closest('.tw-flex.tw-items-center.tw-justify-between')
    if (toggleDiv) {
      toggleDiv.classList.toggle('chat-history-toggle')
    }

    const title = this.element.querySelector('.chat-history-section-title, .tw-text-black')
    if (title && title.closest('.tw-flex.tw-items-center.tw-gap-2')) {
      const isActive = title.classList.contains('chat-history-section-title')
      if (isActive) {
        title.classList.remove('chat-history-section-title')
        title.classList.add('tw-text-black')
      } else {
        title.classList.remove('tw-text-black')
        title.classList.add('chat-history-section-title')
      }
    }

    const icon = this.element.querySelector('.chat-history-icon:not(.chat-sidebar-collapsed-history .chat-history-icon)')
    if (icon) {
      const path = icon.querySelector('path')
      if (path) {
        const currentFill = path.getAttribute('fill')
        path.setAttribute('fill', currentFill === '#E259B0' ? '#000000' : '#E259B0')
      }
    }
  }
}
